<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Setting</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Setting</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Setting">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'SettingList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Type</label>
                    <el-select v-model="value.type" v-validate="'required'" name="type"
                               style="width: 100%" placeholder="Pick a settings type">
                      <el-option
                        v-for="item in [{value: 'offer_bar', label: 'Offer Bar'}]"
                        :key="item.value" v-bind:class="{'has-error' : errors.has('type')}"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('type')">
                      {{ errors.first("type") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Title</label>
                    <input type="text" id="title" name="title"
                           v-bind:class="{'has-error' : errors.has('title')}"
                           v-validate="'required'"
                           v-model="value.title" class="form-control title"
                           placeholder="Title">
                    <div class="help text-danger" v-show="errors.has('title')">
                      {{ errors.first("title") }}
                    </div>
                  </div>
<!--                  <div class="form-group ">
                    <label class="control-label">Description</label>
                    <textarea id="description" name="description"
                              v-model="value.description" class="form-control description"
                              placeholder="Description"
                              rows="3"></textarea>
                  </div>-->
                  <div class="form-group ">
                    <label class="control-label">Call to action</label>
                    <input type="text" id="call_to_action_1" name="call_to_action_1"
                           v-model="value.call_to_action_1" class="form-control"
                           placeholder="Call to action">
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Call to action Label</label>
                    <input type="text" id="call_to_action_1_label" name="call_to_action_1_label"
                           v-model="value.call_to_action_1_label" class="form-control call_to_action_1_label"
                           placeholder="Call to action Label">
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Is active</label>
                    <el-select v-model="value.is_active" v-validate="'required'" name="is_active"
                               style="width: 100%" placeholder="Select active status">
                      <el-option
                        v-for="item in [{value: 'Yes', label: 'Yes'}, {value: 'No', label: 'No'}]"
                        :key="item.value" v-bind:class="{'has-error' : errors.has('is_active')}"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "SettingForm",
  metaInfo: {
    title: "Setting | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {


    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/settings";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/settings/" + _this.$route.params.id
            method = "PUT";
          }


          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "SettingList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/settings/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });


      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

